import * as Api from '@ViewModels';

export enum LeadServedFilterCriteriaProperty {
	Category = 'Category',
	CompanyTag = 'CompanyTag',
	Date = 'Date',
	LeadCallMode = 'LeadCallMode',
	Manager = 'Manager',
	OfficeLocation = 'OfficeLocation',
	Outcome = 'Outcome',
	QuotaTeam = 'QuotaTeam',
	RecordingChannels = 'RecordingChannels',
	Team = 'Team',
	TranscriptionStatus = 'TranscriptionStatus',
	User = 'User',
	UserRole = 'UserRole',
	DealDemoPerformDate = 'DealDemoPerformDate',
	DealStage = 'DealStage',
	CallDuration = 'CallDuration',
	CallType = 'CallType',
	ColdDemo = 'ColdDemo',
}

export type ILeadServedFilterCriteria = Api.IFilterCriteria<LeadServedFilterCriteriaProperty>;

export type ILeadServedFilterRequest = ILeadServedFilterCriteria;
